
export type GetOrderDetail200Order = {
  amount?: number;
  createdAt?: string;
  orderId?: string;
  productName?: string;
  status?: string;
  userId?: string;
};
